import { Trans, useLingui } from '@lingui/react/macro'
import { Alert, Anchor, Button, Select, Stack, Text } from '@mantine/core'
import { IconChevronRight, IconInfoCircle } from '@tabler/icons-react'

interface CityStepProps {
  value: string
  onChange: (city: string) => void
  onNext: () => void
}

export function CityStep({ value, onChange, onNext }: CityStepProps) {
  const { t } = useLingui()

  const CITIES = [
    { value: 'espoo', label: 'Espoo' },
    { value: 'helsinki', label: 'Helsinki' },
    { value: 'kauniainen', label: 'Kauniainen' },
    { value: 'kirkkonummi', label: 'Kirkkonummi' },
    { value: 'vantaa', label: 'Vantaa' },
    { value: 'muu', label: t`Other` },
  ]

  return (
    <Stack gap="md">
      <div>
        <Text size="xl" fw={600} mb="xs">
          <Trans>Select city</Trans>
        </Text>
        <Text size="sm" c="dimmed">
          <Trans>Where is the property located?</Trans>
        </Text>
      </div>

      <Select
        label={t`City`}
        placeholder={t`Select city`}
        data={CITIES}
        value={value}
        onChange={(val) => val && onChange(val)}
        size="md"
        required
      />

      <Alert
        icon={<IconInfoCircle size={18} />}
        color="blue"
        variant="light"
        styles={{ message: { fontSize: 'var(--mantine-font-size-sm)' } }}
      >
        <Trans>The visit takes about an hour</Trans>
      </Alert>

      {value === 'muu' && (
        <Alert
          icon={<IconInfoCircle size={18} />}
          title={t`Outside service area`}
          color="blue"
        >
          <Text>
            <Trans>
              Unfortunately, we do not yet serve your selected area.
            </Trans>
          </Text>
          <Text mt="xs">
            <Trans>
              Markku currently serves the Helsinki metropolitan area and its
              surroundings.
            </Trans>
          </Text>
          <Text mt="xs">
            <Trans>If you are interested in our services, contact us:</Trans>
          </Text>
          <Text mt="xs">
            <Anchor href="mailto:info@markku.fi" fw={500}>
              info@markku.fi
            </Anchor>
          </Text>
          <Text mt="xs" c="dimmed">
            <Trans>We are constantly expanding our service area!</Trans>
          </Text>
        </Alert>
      )}

      <Button
        onClick={onNext}
        disabled={!value || value === 'muu'}
        size="md"
        fullWidth
        rightSection={<IconChevronRight size={18} />}
      >
        <Trans>Continue</Trans>
      </Button>
    </Stack>
  )
}
